export default {
  width: 19,
  height: 19,
  svg: `
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.8999 0.400024C14.8705 0.400024 18.8999 4.42946 18.8999 9.40002C18.8999 14.3706 14.8705 18.4 9.8999 18.4C4.92934 18.4 0.899902 14.3706 0.899902 9.40002C0.899902 4.42946 4.92934 0.400024 9.8999 0.400024ZM9.8999 1.75002C14.1249 1.75002 17.5499 5.17505 17.5499 9.40002C17.5499 13.625 14.1249 17.05 9.8999 17.05C5.67492 17.05 2.2499 13.625 2.2499 9.40002C2.2499 5.17505 5.67492 1.75002 9.8999 1.75002Z"/>
<rect width="1.8" height="7.2" transform="matrix(1 0 0 -1 9.09985 14.4)"/>
<rect width="1.8" height="1.8" transform="matrix(1 0 0 -1 9.09985 5.8501)"/>
`,
}
